import React, { Component } from "react";
import api from "axios";

import ReactTooltip from "react-tooltip";
import Loader from "react-loader-spinner";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";

import history from "./../../utils/history";
import { required, lt, numbersOnly } from "./../../utils/validators";

class GiftPackRegistration extends Component {
  state = {
    isValidating: false,
    hasError: false,
    activationNumber: "",
    barcode: ""
  };

  componentDidMount() {
    document.title = "Gift Pack Activation";
  }

  submit = e => {
    e.preventDefault();

    // TODO: API CALL HERE
    this.setState({ isValidating: true, hasError: false, errorCode: null });
    this.request = api
      .post(this.props.config.apiRequest.validate, {
        activationCode: this.state.activationNumber,
        barcode: this.state.barcode
      })
      .then(response => {
        if (response.data.code === 1) {
          // Update Parent state with verified activation and barcode
          this.props.updateAppState({
            activationNumber: this.state.activationNumber,
            barcode: this.state.barcode
          });

          // Next State
          history.push("/activate");
        } else {
          this.setState({ isValidating: false, hasError: true, errorCode: response.data.message });
        }
      })
      .catch(() => {
        // Unexpected Error
        this.setState({ isValidating: false, hasError: true, errorCode: "UNKNOWN_ERROR" });
      });
  };

  displayErrorMessage = code => {
    let errorPrefix = <span>There has been an issue activating this product.</span>;
    let errorSuffix = (
      <span>
        If the issue persists please contact our <a href="https://www.whsmith.co.uk/fcp/content/contact-us/content">customer services team</a>.
      </span>
    );
    let errorMsg = <span>Please check the Activation Code and Barcode has been entered correctly.</span>;

    if (code === "NOT_WHS") {
      errorMsg = (
        <span>
          Please check the Gift Pack{" "}
          <a href="https://www.whsmith.co.uk/fcp/content/Help-GiftPackandGiftCard-RegisterYourGiftPack/content">Type Here</a>.
        </span>
      );
    }

    return (
      <div className="mt-3 form-error text-center">
        <span>
          {errorPrefix}
          <br />
          {errorMsg}
          <br />
          {errorSuffix}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div id="gift-pack-registration-wrapper">
        <div className="row justify-content-center">
          <div className="col-xs-12 col-sm-10 col-lg-8 col-xl-6">
            <Form
              ref={c => {
                this.form = c;
              }}
              onSubmit={this.submit}
            >
              <h2>Gift Pack Activation</h2>
              <hr className="colorgraph" />
              <p>
                Welcome to the WHSmith gift pack activation page. Using the form below you will be able to activate your subscription, book your
                experience or activate your voucher.
              </p>

              <div className="form-group">
                <label className="label">
                  Activation Code <span className="required">*</span>{" "}
                  <a data-tip data-for="wheres-my-code-tip" className="ml-2">
                    (?)
                  </a>
                </label>
                <ReactTooltip id="wheres-my-code-tip" type="dark" place="top" effect="solid">
                  You can find your 13 digit activation code next to your barcode.
                </ReactTooltip>
                <Input
                  ref={c => {
                    this.activationNumberInput = c;
                  }}
                  id="activationNumber"
                  type="text"
                  name="activationNumber"
                  className="form-control input-lg"
                  placeholder="Activation Code"
                  value={this.state.activationNumber}
                  onChange={this.updateInput}
                  maxLength="13"
                  validations={[required, lt]}
                  tabIndex="1"
                />
              </div>
              <div className="form-group">
                <label className="label">
                  Barcode <span className="required">*</span>
                </label>
                <Input
                  id="barcode"
                  type="text"
                  className="form-control input-lg"
                  name="barcode"
                  placeholder="Barcode"
                  value={this.state.barcode}
                  onChange={this.updateInput}
                  tabIndex="2"
                  validations={[required, numbersOnly]}
                />
              </div>
              {this.state.hasError ? this.displayErrorMessage(this.state.errorCode) : ""}
              <hr className="colorgraph" />
              {!this.state.isValidating ? (
                <Button className="btn btn-primary btn-block btn-lg" tabIndex="3">
                  CONTINUE
                </Button>
              ) : (
                <div className="row justify-content-center">
                  <Loader type="Oval" color="#003087" height="40" width="40" />
                </div>
              )}
            </Form>
            <div className="mt-2">
              For any issues during registration please contact our{" "}
              <a href="https://www.whsmith.co.uk/fcp/content/contact-us/content">customer services team</a>.
            </div>
          </div>
        </div>
      </div>
    );
  }

  updateInput = evt => {
    this.setState({
      [evt.target.name]: evt.target.value
    });
  };
}

export default GiftPackRegistration;



// WEBPACK FOOTER //
// ./src/pages/validation/giftPackRegistration.jsx